import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';

import { Badge } from 'DesignSystem/ui/badge';

type Props = {
  row: Row<UpstreamEvent>;
};

export function Status({ row }: Props) {
  const status = row.original.status;

  if (!status) return <>–</>;

  switch (status.toLowerCase()) {
    case 'announced':
      return <Badge className="bg-violet-200 text-violet-950">{status}</Badge>;
    case 'ongoing':
      return <Badge className="bg-cyan-100 text-cyan-950">{status}</Badge>;
    case 'resolved':
      return <Badge className="bg-zinc-200 text-zinc-800">{status}</Badge>;
    default:
      return <Badge variant="informative">{status}</Badge>;
  }
}
